/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module special-characters/specialcharactersarrows
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
/**
 * A plugin that provides special characters for the "Arrows" category.
 *
 *		ClassicEditor
 *			.create( {
 *				plugins: [ ..., SpecialCharacters, SpecialCharactersArrows ],
 *			} )
 *			.then( ... )
 *			.catch( ... );
 *
 * @extends module:core/plugin~Plugin
 */
export default class SpecialCharactersArrows extends Plugin {
    /**
	 * @inheritDoc
	 */
    init() {
        const editor = this.editor;
        const t = editor.t;
        editor.plugins.get('SpecialCharacters').addItems('Arrows', [
            {
                title: t('j'),
                character: '\u21D0'
            },
            {
                title: t('k'),
                character: '\u21D2'
            },
            {
                title: t('l'),
                character: '\u21D1'
            },
            {
                title: t('m'),
                character: '\u21D3'
            },
            {
                title: t('n'),
                character: '\u21E0'
            },
            {
                title: t('o'),
                character: '\u21E2'
            },
            {
                title: t('p'),
                character: '\u21E1'
            },
            {
                title: t('q'),
                character: '\u21E3'
            },
            {
                title: t('r'),
                character: '\u21E4'
            },
            {
                title: t('s'),
                character: '\u21E5'
            },
            {
                title: t('t'),
                character: '\u2912'
            },
            {
                title: t('u'),
                character: '\u2913'
            },
            {
                title: t('v'),
                character: '\u21A8'
            },
            {
                title: t('w'),
                character: '\uD83D\uDD19'
            },
            {
                title: t('x'),
                character: '\uD83D\uDD1A'
            },
            {
                title: t('y'),
                character: '\uD83D\uDD1B'
            },
            {
                title: t('z'),
                character: '\uD83D\uDD1C'
            },
            {
                title: t('aa'),
                character: '\uD83D\uDD1D'
            }
        ]);
    }
}